import { MTypeDTOFireProtectionTypeEnum } from '~/api/webservice';
import { HeightOffsetTypeProductDto, ISOPROProductBendingMomentType } from '~/models/product';
import { useProductsStore } from '~/store';

export class ISOPROProductHeightOffsetVariantType extends ISOPROProductBendingMomentType {
  readonly variant: HeightOffsetTypeProductDto["variant"];
  declare readonly type: HeightOffsetTypeProductDto["type"];
  declare readonly height: HeightOffsetTypeProductDto["height"];
  declare readonly fireProtectionType: HeightOffsetTypeProductDto["fireProtectionType"];
  declare readonly capacity: HeightOffsetTypeProductDto["capacity"];
  readonly minimumWallThickness: string | number;
  readonly minimumCeilingThickness?: number;

  constructor (data: HeightOffsetTypeProductDto) {
    super(data);
    this.type = data.type;
    this.variant = data.variant;
    this.height = data.height;
    this.capacity = data.capacity;
    this.minimumWallThickness = data.minimumWallThickness;
    if (data.variant === 'UV')
      this.minimumCeilingThickness = data.minimumCeilingThicknessHD;
  }

  getOneWithoutFireProtection (): ISOPROProductHeightOffsetVariantType | null {
    if (this.hasFireProtection) return null;
    const rowKey = `${this.rowKey} ${MTypeDTOFireProtectionTypeEnum.Rei120}`;
    return (useProductsStore().productsMap.get(rowKey) as ISOPROProductHeightOffsetVariantType) || null;
  }
}
